import { createTheme } from "@mui/material"

const theme = createTheme({
  typography: {
    fontFamily: ["Noto Sans", "Noto Serif", "sans-serif", "serif"].join(","),
  },
})

export default theme
